import FullHeader from './full-header';
import ScrolledHeader from './scrolled-header';

export interface HeaderProps {
  sticky?: boolean;
  isScrolled?: boolean;
}

export default function Header(props: HeaderProps = {}) {
  const { sticky = false } = props;
  const { isScrolled = false } = props;

  const headerPosition = sticky ? 'fixed top-0 left-0' : 'absolute';
  return (
    <header className={`${headerPosition} w-full z-30 bg-brandred-500`}>
      {isScrolled ? <ScrolledHeader /> : <FullHeader />}
    </header>
  );
}
